
import { logger } from '@/lib/logger';

/**
 * Utility for consistent logging in database operations
 */
export const dbLogger = {
  info: (message: string, context?: Record<string, any>) => {
    logger.info({
      message,
      context
    });
  },
  
  error: (message: string, error: unknown, context?: Record<string, any>) => {
    logger.error({
      message,
      error: error instanceof Error ? error : new Error(String(error)),
      context
    });
  }
};
